module.exports = __webpack_public_path__ + "img/logo_google.69c30ac9.svg";